import { concat, isEmpty, get, cloneDeep } from 'lodash';
import IndicatorType from './Indicator.type';
import { Page_Size } from '../../../../../Components/helper';

const initialState = {
  indicatorListData: [],
  indicatorSelectedIds: [],
  mainSamples: [],
  currentRequestId: null,
  indicatorFilterValues: {
    selected_Season: [],
    selected_Year: [],
    selected_Month: [],
    selected_Brand: [],
    selected_Supplier: [],
    selected_Type: '',
    selected_Category1: [],
    selected_Category2: [],
    selected_Category3: [],
    selected_Category4: [],
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
    pageIndex: 1,
    pageSize: Page_Size,
    loading: false,
  },
  indicatorListTotalCount: 0,
};

const indicatorTodoListReducer = (state = initialState, action) => {
  switch (action.type) {
    case IndicatorType.SET_INDICATOR_REQUESTS_TODOLIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }
      const updatedArry = cloneDeep(setArrayByCase(state.indicatorListData, action.payload));
      return {
        ...state,
        indicatorListData: updatedArry,
        indicatorListTotalCount: action.payload.totalCount,
        currentRequestId: action.payload.requestId || state.currentRequestId,
      };
    }
    case IndicatorType.SET_PROGRESS_SELECTED_IDS_ARRAY:
      return {
        ...state,
        indicatorSelectedIds: action.payload,
      };
    case IndicatorType.SET_FILTER_SORT_DATA:
      return {
        ...state,
        indicatorFilterValues: {
          ...state.indicatorFilterValues,
          ...action.payload,
        },
      };
    case IndicatorType.GET_MAIN_SAMPLES:
      return {
        ...state,
        mainSamples: action.payload,
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    array = [...array, ...payload.data];
    return array;
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    array = payload.data;
    return array;
  }
  if (get(payload, 'isScrolled')) {
    array = concat(array, payload.data);
    return array;
  }
  return payload.data;
};

export default indicatorTodoListReducer;
